export default __webpack_public_path__ + "static/media/12.ec6b80b9.jpg";